export const useSnapshot = () => useState('snapshot', () => ({
    initCallDone: false,
    snapshotData: null
}));